import { useEffect } from 'react';
import { useAtom } from 'jotai';
import {
  comingFromLogoutAtom,
  failedLoginAtom,
  failedLoginMessageAtom,
  provisioningErrorHandledAtom,
} from 'auth/userStore';
import { useRouter } from 'next/router';
import boatsetterPaths from 'utils/boatsetterPaths';
import useLazySnackbar from 'components/banners/useLazySnackbar';

export const useProtectedUrlGuard = (isProtected: boolean) => {
  const [comingFromLogout, setComingFromLogout] = useAtom(comingFromLogoutAtom);
  const [loginFailed, setLoginFailed] = useAtom(failedLoginAtom);
  const [loginFailedMessage, setLoginFailedMessage] = useAtom(failedLoginMessageAtom);
  const [provisioningHandled, setProvisioningHandled] = useAtom(provisioningErrorHandledAtom);
  const { enqueueSnackbar } = useLazySnackbar();
  const router = useRouter();

  useEffect(() => {
    if (loginFailed && !provisioningHandled && loginFailedMessage !== '') {
      enqueueSnackbar(loginFailedMessage, { variant: 'error' });
      setLoginFailedMessage('');
      setProvisioningHandled(true);
    }
  }, [loginFailed, provisioningHandled, loginFailedMessage]);

  useEffect(() => {
    // if page is not protected don't redirect
    if (!isProtected) return;

    // if page is redirected and user failed login redirect to login
    if (loginFailed) {
      setLoginFailed(false);
      router.push({
        pathname: boatsetterPaths.logIn,
        query: {
          redirect_to: `${window?.location?.pathname}${window?.location?.search}`,
        },
      });
    }

    // if user came to auth only page from logout redirect, redirect to homepage
    if (comingFromLogout) {
      setComingFromLogout(false);
      router.push('/');
    }
  }, [isProtected, comingFromLogout, loginFailed]);
};
